<script setup>
import {ref, onBeforeMount} from "vue"
import {competitionStateEnum} from "@/enum/competitionStateEnum.js";

const props = defineProps({
  state: {
    required: true,
    type: String,
    default: "PENDING_SIGNUP"
  }
})

// 执行订单判断
onBeforeMount(() => {
  handleEnum()
})

// 报名状态枚举
const state = competitionStateEnum

// 展示的文本类型
const textType = ref("info")
// 状态名称
const stateName = ref("未知状态")

// 根据枚举返回订单状态
const handleEnum = () => {
  try {
    const res = state.find(res => res.stateId === props.state)
    stateName.value = res.stateName ? res.stateName : "未知状态"
    switch (props.state) {
      case "PENDING_SIGNUP":
        textType.value = "info"
        break
      case "SIGNING_UP":
        textType.value = "primary"
        break
      case "PENDING_COMPETITION":
        textType.value = "warning"
        break
      case "IN_COMPETITION":
        textType.value = "danger"
        break
      case "COMPLETED":
        textType.value = "success"
        break
    }
  } catch (e) {
    console.log(e)
  }
}
</script>

<template>
  <el-text :type="textType" v-text="stateName"></el-text>
</template>

<style scoped>

</style>